// Lead form on the public marketing page.
//
// Deliberately not a Stimulus controller: registering it in
// app/javascript/controllers/index.js would pull the whole application bundle
// (~460 KB unminified) onto a marketing page that needs none of it. The
// transport still follows docs/crud-paradigm.md — fetch + JSON with the CSRF
// token in the X-CSRF-Token header.
//
// esbuild picks this file up automatically: `yarn build` globs
// app/javascript/*.* into app/assets/builds/, which manifest.js already links.

const SUCCESS_ICON = `
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
       stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M9 12.75 11.25 15 15 9.75"/>
    <circle cx="12" cy="12" r="9"/>
  </svg>`;

function init() {
  const form = document.getElementById("lead-form");
  if (!form) return;

  const card = document.getElementById("lead-form-card");
  const button = form.querySelector("button[type=submit]");
  const alertBox = form.querySelector("[data-form-alert]");

  const clearErrors = () => {
    form.querySelectorAll("[data-error]").forEach((el) => (el.textContent = ""));
    form.querySelectorAll("[data-error-for]").forEach((el) => el.removeAttribute("aria-invalid"));
    alertBox.hidden = true;
    alertBox.textContent = "";
  };

  const showFieldErrors = (errors) => {
    let firstInvalid = null;
    Object.entries(errors || {}).forEach(([field, messages]) => {
      const slot = form.querySelector(`[data-error="${field}"]`);
      const input = form.querySelector(`[data-error-for="${field}"]`);
      if (slot) slot.textContent = [].concat(messages)[0] || "";
      if (input) {
        input.setAttribute("aria-invalid", "true");
        if (!firstInvalid) firstInvalid = input;
      }
    });
    if (firstInvalid) firstInvalid.focus();
  };

  const showAlert = (message) => {
    alertBox.textContent = message;
    alertBox.hidden = false;
  };

  const setBusy = (busy) => {
    button.disabled = busy;
    button.textContent = busy
      ? button.dataset.submittingLabel
      : button.dataset.submitLabel;
  };

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    clearErrors();
    setBusy(true);

    const csrf = document.querySelector('meta[name="csrf-token"]')?.content;

    try {
      const response = await fetch(form.action, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": csrf || "",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: new FormData(form),
      });

      // A non-JSON body means something upstream failed (proxy error page,
      // session timeout); fall through to the generic message.
      const payload = await response.json().catch(() => null);

      if (response.ok && payload?.ok) {
        card.innerHTML = `
          <div class="form-success">
            ${SUCCESS_ICON}
            <h3></h3>
            <p></p>
          </div>`;
        card.querySelector("h3").textContent = payload.title;
        card.querySelector("p").textContent = payload.message;
        card.setAttribute("role", "status");
        card.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }

      if (payload?.errors) showFieldErrors(payload.errors);
      if (payload?.message) showAlert(payload.message);
      else if (!payload?.errors) showAlert(form.dataset.genericError || "");
    } catch {
      showAlert(form.dataset.genericError || "");
    } finally {
      // Runs on the success path too, but there the form has already been
      // replaced and `button` is detached — so this only ever matters when the
      // visitor still has a form in front of them.
      setBusy(false);
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
